import { useEffect, useState } from "react";
import { Button } from "@/components/ui/Button.tsx";
import CloseIcon from "@/components/icons/availability/CloseIcon.tsx";
import { useTranslation } from "react-i18next";

interface Props {
  isValidSelection: boolean;
}

export function AvailabilityPopup({ isValidSelection }: Props) {
  const { t } = useTranslation();
  
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(isValidSelection);
     
  }, [isValidSelection]);

  if (!show) return <></>;

  return (
    <div className="mx-auto left-0 md:left-auto  right-0  max-w-md absolute  bg-light rounded-lg bottom-10  w-full flex flex-row-reverse py-3 px-3 lg:px-8 items-center">
      <Button
        className="ml-auto hover:bg-transparent"
        onClick={() => {
          setShow(false);
        }}
        variant={"ghost"}
      >
        <CloseIcon className={"fill-brand-secondary w-5 h-5"} />
      </Button>
      <p className="text-brand-deep lg:text-xl text-14px  text-center font-semibold  w-full">
        {t("availability.notice_do")}
      </p>
    </div>
  );
}

export default AvailabilityPopup;
